import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../store/store";
import FiscalPrecinctService from "../../services/fiscalPrecincts/FiscalPrecinctService";
import { loadingFiscalPrecinctDropdown } from "../../store/slices/fiscalPrecincts/fiscalPrecinctSlice";

export const useFiscalPrecinct = () => {
  const dispatch: AppDispatch = useDispatch();

  const { fiscalPrecinctDropdown } = useSelector(
    (state: RootState) => state.fiscalPrecinct
  );

  const fetchFiscalPrecinctDropdown = async (term: string) => {
    try {
      const response = await FiscalPrecinctService.fetchDropdown(term);

      const { data, statusCode } = response;

      if (statusCode === 200) {
        dispatch(loadingFiscalPrecinctDropdown(data));
      }
    } catch (error) {
      console.error("Error al cargar recintos fiscales:", error);
    }
  };

  return {
    fiscalPrecinctDropdown,
    fetchFiscalPrecinctDropdown,
  };
};
